<template>
  <!-- star -->

  <div class="youjiaopage_wrap">
    <banner2 :bannerImg="Img1"></banner2>
    <!-- 面包屑 -->
    <div class="Crumbs">
      <div>
        当前位置：<router-link to="/">首页</router-link> &gt;
        <span>新闻资讯</span>
      </div>
    </div>
    <!-- 导航板块 -->
    <div class="news-nav-container">
      <div class="nav_cont">
        <router-link
          v-for="(item, index) in newsList"
          :key="index"
          :to="{ name: item.url }"
          class="nav-item"
          active-class="active"
        >
          {{ item.title }}
        </router-link>
      </div>
    </div>
    <!-- 新闻内容 -->
    <div class="news-content-view">
      <keep-alive v-if="$route.meta.keepAlive">
        <router-view :key="$route.fullPath"></router-view>
      </keep-alive>
      <router-view v-else :key="$route.fullPath"></router-view>
    </div>

    <!-- end -->
  </div>
</template>

<script>
import banner2 from "../components/banner.vue";

export default {
  name: "news",
  components: {
    banner2,
  },
  data() {
    return {
      h1: "新闻资讯",
      p1: "更多最新精彩资讯",
      newsList: [
        {
          title: "全部资讯",
          url: "AllNews",
        },
        {
          title: "招投标资讯",
          url: "GroupNews",
        },
        {
          title: "财政资讯",
          url: "TradeNews",
        },
        {
          title: "政策文件",
          url: "MediaCoverage",
        },
      ],
      Img1: require("../assets/images/newsbanner.jpg"),
    };
  },
};
</script>
<style lang="less" scoped>
.youjiaopage_wrap {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f8fafc; // 大厂常用的极浅灰蓝背景
}

/* 面包屑 - 极简主义 */
.Crumbs {
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
  padding: 20px 0;
  font-size: 14px;
  color: #64748b; // 莫兰迪色系，更高级

  a {
    color: inherit;
    transition: color 0.3s;
    &:hover {
      color: #3494ec;
    }
  }

  span {
    color: #1e293b;
    font-weight: 500;
    margin-left: 8px;
  }
}

/* 导航标签 - 现代化大厂风格 (如腾讯/阿里) */
.news-nav-container {
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

.nav_cont {
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
  display: flex;
  justify-content: center; // 居中导航更具官网感
  gap: 40px;
}

.nav-item {
  position: relative;
  padding: 20px 0;
  font-size: 16px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;

  &::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    width: 0;
    height: 3px;
    background: #3494ec;
    transition: all 0.3s ease;
    transform: translateX(-50%);
    border-radius: 3px 3px 0 0;
  }

  &:hover {
    color: #3494ec;
  }

  &.active {
    color: #3494ec;
    &::after {
      width: 100%;
    }
  }
}

/* 内容区域 */
.news-content-view {
  flex: 1;
  max-width: 1200px;
  width: 95%;
  margin: 0 auto;
  padding: 40px 0 80px;
  min-height: 600px;
  position: relative;
}

/* 全局覆盖子组件样式，确保一致性 */
::v-deep {
  .news_cont_zong {
    display: flex;
    flex-direction: column;
    gap: 24px;
  }

  // 统一 Loading 样式
  .el-loading-mask {
    background-color: rgba(248, 250, 252, 0.7);
  }
}
</style>
